import {jump} from '@utils'
import TopBar from '@components/topBar'
import FootBar from '@components/footBar'
import WrapManage from '@components/wrapManage'
const {WrapContent,ToBind,BtnList} = WrapManage

const components = {TopBar,WrapManage,WrapContent,ToBind,BtnList,FootBar}

import iconRefuse from '@assets/images/enterManage/refuse.svg'

export default {
    components,
    data(){
        return {
            iconRefuse
        }
    },
    beforeCreate(){
        this.$store.dispatch('getUserInfo')
    },
    methods:{
        iKnow(){
           //关闭当前页
           jump.closeCurrent();
        }
    }
}